import React from 'react';

const StepReviewSubmit = ({ data, setData, onPrev, onSave, saving }) => {
  const handleNameChange = (e) => {
    setData((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  return (
    <main className="rbt-main-wrapper">
      <div className="container custom-checkout-container">
        <div className="row">
          <div className="">
            <div className="review-submit-container">
              <h3 className="text-center mb-4">Review Your SmartSize Profile</h3>

              <div className="form-group">
                <label className="smartsize-label">
                  Name your SmartSize profile:
                </label>
                <br />
                <br />
                <input
                  type="text"
                  className="form-control"
                  placeholder="e.g., My Regular Fit"
                  value={data.name}
                  onChange={handleNameChange}
                  required
                />
              </div>

              <div className="summary-list mt-4">
  <div className="table-responsive">
    <table className="table table-bordered">
      <tbody>
        <tr>
          <th style={{ width: '40%' }}>T-Shirt Size:</th>
          <td>{data.tShirtSize}</td>
        </tr>
        <tr>
          <th>Height:</th>
          <td>{data.height}</td>
        </tr>
        <tr>
          <th>Weight:</th>
          <td>{data.weight}</td>
        </tr>
        <tr>
          <th>Waist:</th>
          <td>{data.waist}</td>
        </tr>
        <tr>
          <th>Belly Size:</th>
          <td>{data.bellySize}</td>
        </tr>
        <tr>
          <th>Chest &amp; Shoulders:</th>
          <td>{data.chestShoulders}</td>
        </tr>
        <tr>
          <th>Collar Size:</th>
          <td>{data.collarSize}</td>
        </tr>
        <tr>
          <th>Sleeve Length:</th>
          <td>{data.sleeveLength}</td>
        </tr>
        <tr>
          <th>Tuck Preference:</th>
          <td>{data.tuckPreference}</td>
        </tr>
        <tr>
          <th>Fit Preference:</th>
          <td>{data.fitPreference}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


              <div className="fit-select-nav mt-4" style={{ display: 'flex', gap: '10px' }}>
                <button
                  type="button"
                  className="fit-select-prev-btn"
                  onClick={onPrev}
                >
                  Prev
                </button>
                <button
                  type="button"
                  className="rbt-btn btn-gradient btn-md w-100"
                  onClick={onSave}
                  disabled={saving}
                >
                  {saving ? 'Saving...' : 'Save SmartSize'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default StepReviewSubmit;
